import React from "react";
import { Modal } from "antd";

import authorization from "../../../auth/authorization";
import AddTelemedicine from "./AddTelemedicine";
import EditTelemedicine from "./EditTelemedicine";

const TelemedicineCategoryFormModal = ({
  open,
  editId,
  userType,
  onCancel,
  addState,
  afterEdit,
  fetchTelecategoryAfterUpdate,
}) => (
  <Modal
    title={editId ? "Edit Telemedicine Category" : "Add Telemedicine Category"}
    open={open}
    footer={null}
    width={900}
    destroyOnClose
    onCancel={onCancel}
  >
    {editId && authorization.isAllowed(userType, "updateTeleMedicineCategory") ? (
      <EditTelemedicine
        categoryId={editId}
        afterEdit={afterEdit}
        fetchTelecategoryAfterUpdate={fetchTelecategoryAfterUpdate}
      />
    ) : (
      <AddTelemedicine addState={addState} />
    )}
  </Modal>
);

export default TelemedicineCategoryFormModal;
